module.exports = __webpack_public_path__ + "img/webeditor-4.d3a3667b.gif";